import { useEffect } from 'react';

import { BrowserRouter } from 'react-router-dom';

import gtm from './shared/gtm';

import './App.css';

import 'react-toastify/dist/ReactToastify.css';

import { TimerProvider } from './hooks/useTimer';
import { ModalProvider } from './hooks/useModal';
import { IsMobileProvider } from './hooks/useMobile';
import { AuthProfileProvider } from './hooks/useAuthProfile';
import { CourseCategoriesProvider } from './contexts/CourseCategoriesContext';
import { AppRouter } from './routes/AppRouter';

import { ToastContainer } from 'react-toastify';

const App = () => {
  useEffect(() => {
    gtm();
  }, []);

  return (
    <BrowserRouter>
      <AuthProfileProvider>
        <IsMobileProvider>
          <TimerProvider>
            <ModalProvider>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              <CourseCategoriesProvider>
                <AppRouter />
              </CourseCategoriesProvider>
            </ModalProvider>
          </TimerProvider>
        </IsMobileProvider>
      </AuthProfileProvider>
    </BrowserRouter>
  );
};

export default App;
